<script setup lang="ts">
import { useStoreTranslations } from '../../../../store/translations/translations';

type Props = {
  isActive: boolean;
};

defineProps<Props>();

const emit = defineEmits(['click']);

const storeTranslations = useStoreTranslations();
</script>

<template>
  <button
    :aria-label="storeTranslations.translations?.['toggleButton.title'] || 'Open / Close'"
    :class="[$style.container, isActive && $style.isOpen]"
    @click="emit('click')"
  >
    <span class="accessible-link-text">{{
      isActive
        ? storeTranslations.translations?.['toggleButton.labelActive']
        : storeTranslations.translations?.['toggleButton.label']
    }}</span>
  </button>
</template>

<style module lang="scss">
@forward './ToggleButton.scss';
</style>
